import React from 'react';
import { createNewPartner } from '../../../../Apis/partnersApi';
import Form from './Form';

export default function Addpartner() {
    const onSubmit = async (e, data) => {
        e.preventDefault();
        console.log(data)
        //to send request
        return await createNewPartner(data).then(res => {
            console.log(res.data.data);
            return 'done';      
        }).catch(err =>{
            console.log(err.response);
            return err.response.data.errors;
        })
    };

    return (
        <Form onSubmit={onSubmit}></Form>
    )
}
